
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '../reducers/brokerConfig.reducers';

export const selectDataState = createFeatureSelector<State>('brokerConfigData');

export const selectBrokerConfigData = createSelector(selectDataState, (state) => state.brokerConfigData);
export const selectBrokerConfigLoading = createSelector(selectDataState, (state) => state.loading);
export const selectBrokerConfigError = createSelector(selectDataState, (state) => state.error);
